import React from "react";
import { t } from "i18next";
import type { IEmailCampaignTopLink } from "api/rpc/2024-04/facilityAdmin/marketing/emailCampaigns";
import { ButtonNew } from "components/buttonNew";
import { NavigationDropdownNew } from "components/navigationDropdownNew/NavigationDropdownNew";
import { getEmailCampaignTopLinkLabel } from "./emailCampaignTopLinks";

export function TopLinksFilter(props: {
  links: IEmailCampaignTopLink[];
  selected?: IEmailCampaignTopLink;
  onChange: (url: string) => void;
}) {
  const selectedLabel = props.selected ? getEmailCampaignTopLinkLabel(props.selected) : null;

  return (
    <NavigationDropdownNew
      rightAlign
      showPlainTextLabel
      label={
        <ButtonNew type="default" size="small" className="max-w-[280px]">
          <span className="truncate">
            {selectedLabel
              ? `${selectedLabel} · ${props.selected?.count ?? 0} ${t("clicks")}`
              : t("Select link")}
          </span>
        </ButtonNew>
      }
      sections={[
        props.links.map(link => ({
          label: `${getEmailCampaignTopLinkLabel(link)} · ${link.count} ${t("clicks")}`,
          onClick: () => props.onChange(link.url),
        })),
      ]}
    />
  );
}
